import React from 'react';
import ReactDOM from 'react-dom';
import {Route, Router, Switch} from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';

import './css/index.css';
import Login from './view_components/login';
import Signup from './view_components/sign_up';
import ForgotPassword from './view_components/forgot_password';
import ForgotPasswordMsg from './view_components/forgot_password_msg';
import Home from './view_components/home';
import View_Order from './view_components/view_order';
import Add_Card from './view_components/add_card';
import CheckoutConfirm from './view_components/checkout_confirm';
import AccountSetup from './view_components/account_setup';
import CardAdded from './view_components/card_added';
import Profile from './view_components/profile';
import PaymentMethods from './view_components/payment_methods';
import OrderHistory from './view_components/order_history';
import HelpCenter from './view_components/help_center';
import Startup from './view_components/startup';
import EditProfile from './view_components/edit_profile';
import CardCheckout from './view_components/card_checkout';
import termsOfService from './view_components/terms_of_service';
import privacyPolicy from './view_components/privacy_policy';
import notfound404 from './view_components/notfound404';
import guestCheckout from './view_components/guest_checkout';
import order_summary from "./view_components/order_summary";
import view_product from "./view_components/view_product";
import reset_password from "./view_components/reset_password";
import password_reset_success from "./view_components/password_reset_success";
import refundPolicy from "./view_components/refund_policy";
import rewards from "./view_components/rewards";
import contact from "./view_components/contact";
import './i18n';


const history = createBrowserHistory();


ReactDOM.render(
    <Router history={history}>
        <Switch>
            <Route exact path="/" component={Startup}/>
            <Route exact path="/login" component={Login}/>
            <Route exact path="/signup" component={Signup}/>
            <Route exact path="/forgotpassword" component={ForgotPassword}/>
            <Route exact path="/changepassword/confirm" component={ForgotPasswordMsg}/>
            <Route exact path="/menu" component={Home}/>
            <Route exact path="/order/view" component={View_Order}/>
            <Route exact path="/card/add/:cardId" component={Add_Card}/>
            <Route exact path="/checkout/confirm" component={CheckoutConfirm}/>
            <Route exact path="/myaccount" component={AccountSetup}/>
            <Route exact path="/card/success" component={CardAdded}/>
            <Route exact path="/profile" component={Profile}/>
            <Route exact path="/payment/methods" component={PaymentMethods}/>
            <Route exact path="/order/history" component={OrderHistory}/>
            <Route exact path="/helpcenter" component={HelpCenter}/>
            <Route exact path="/profile/edit/:custId" component={EditProfile}/>
            <Route exact path="/checkout/card" component={CardCheckout}/>
            <Route exact path="/terms" component={termsOfService}/>
            <Route exact path="/policy" component={privacyPolicy}/>
            <Route exact path="/refundpolicy" component={refundPolicy}/>
            <Route exact path="/404" component={notfound404}/>
            <Route exact path="/checkout/guest" component={guestCheckout}/>
            <Route exact path="/order/summary/:orderId" component={order_summary}/>
            <Route exact path="/product/details" component={view_product}/>
            <Route exact path="/password/reset/:randomNumber" component={reset_password}/>
            <Route exact path="/password/confirm" component={password_reset_success}/>
            <Route exact path="/contact" component={contact}/>
            <Route exact path="/rewards" component={rewards}/>
        </Switch>
    </Router>

    , document.getElementById('root'));

export default history;


// WEBPACK FOOTER //
// ./src/index.js